<template>
  <div id="user">
    <el-container class="container" :style="{height:containerHeight}">
      <el-main class="main">
        <div class="main-in">
          <p>服务记录</p>
          <p >
            <span style="margin-right: 48px;">
              <span class="key">状态：</span>
              <el-select v-model="select" placeholder="请选择">
                <el-option label="全部" value="1"></el-option>
                <el-option label="未处理" value="2"></el-option>
                <el-option label="处理中" value="3"></el-option>
                <el-option label="已完成" value="4"></el-option>
              </el-select>
            </span>
            <span style="margin-right: 48px;">
              <span class="key">项目名称：</span>
              <el-input v-model="input" placeholder="请输入"></el-input>
            </span>
            <span>
              <span class="key">时间：</span>
              <el-date-picker v-model="time" type="daterange" range-separator="⇀"
                start-placeholder="开始日期" end-placeholder="结束日期" clear-icon="false" style="margin-right: 48px;">
              </el-date-picker>
            </span>
            <a style="margin-top: 40px;" class="tab-programme-a" href=""
              @click="routerNewsMore('/')">查询</a>
          </p>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{
background:'#FAFAFA',color:'#333333' }" :cell-style='cellStyle'>
              <el-table-column prop="number" label="编号" width="196" type="index">
              </el-table-column>
              <el-table-column prop="project" label="服务项目" width="196">
              </el-table-column>
              <el-table-column prop="contract" label="合同编号">
              </el-table-column>
              <el-table-column prop="quantity" label="产品数量" width="196" type="index">
              </el-table-column>
              <el-table-column prop="state" label="状态" width="196">
                <template #default="{row}">
                  <el-badge is-dot :type="formateSate(row.state)"
                    style="line-height: 8px;margin-right: 8px;">
                  </el-badge>{{row.state}}
                </template>
              </el-table-column>
              <el-table-column prop="term" label="服务期限">
              </el-table-column>
              <el-table-column prop="person" label="负责人" width="196">
              </el-table-column>
              <el-table-column prop="operation" label="操作" width="196">
                <span @click="details">详情</span>
              </el-table-column>
            </el-table>
            <el-dialog :lock-scroll="false" v-if="dialogVisible" title="查看详情"
              :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
              :close-on-press-escape="false">
              <div class="dialog">
                <div style="margin-bottom: 16px">
                  <span style="margin-right: 165px;">
                    <sapn class="key">服务项目：</sapn>
                    <span class="value">DGX A800</span>
                  </span>
                  <span>
                    <span class="key">合同编号：</span>
                    <span class="value">SSH 登录</span>
                  </span>
                </div>
                <div style="margin-bottom: 16px;">
                  <span style="margin-right: 197px;">
                    <span class="key">产品数量：</span>
                    <span class="value">10台</span>
                  </span>
                  <span>
                    <span class="key">服务期限：</span>
                    <span class="value">2021/1/1--2030/1/1</span>
                  </span>
                </div>
                <div style="margin-bottom: 16px">
                  <span style="margin-right: 214px;">
                    <sapn class="key">负责人：</sapn>
                    <span class="value">于维</span>
                  </span>
                  <span>
                    <span class="key">联系方式：</span>
                    <span class="value">18766778899</span>
                  </span>
                </div>
                <div style="margin-top: 24px;">
                  <span class="key">预约详情：</span>
                  <div class="details value">
                    NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                    平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                  </div>
                </div>
                <div style="margin-top: 24px;">
                  <span class="key">备注：</span>
                  <div class="details value">
                    NVIDIA DGX™ A100 是适用于所有 AI 工作负载的通用系统，为全球首款 5 petaFLOPS AI
                    系统提供超高的计算密度、性能和灵活性。NVIDIA DGX A800 采用全球超强大的加速器 NVIDIA A100 Tensor Core
                    GPU，可让企业将深度学习训练、推理和分析整合至一个易于部署的统一 AI 基础架构中，该基础架构具备直接联系 NVIDIA AI 专家的功能。
                  </div>
                </div>
              </div>
            </el-dialog>
            <div class="pagination">
              <el-pagination style="text-align:right" background layout="prev, pager, next"
                :total="1000">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    return {
      select: '1',
      input: '',
      time: '',
      dialogVisible: false,
      textarea: '',
      containerHeight:null,
      tableData: [
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '未读',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        },
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '未处理',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '处理中',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        },
      ]
    }
  },
  created(){
    this.containerHeight = document.body.clientHeight - 104 + 'px'
  },
  methods: {
    details () {
      this.$router.push('/user/singleRecord')
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 单元格的 style 的回调方法
    cellStyle ({ columnIndex }) {
      if (columnIndex === 7) {
        return `color: #77BA00;`
      } else {
        return ''
      }
    },
    formateSate (state) {
      let nowState
      switch (state) {
        case '未读':
          nowState = 'success'
          break
        case '未处理':
          nowState = 'danger'
          break
        case '处理中':
          nowState = 'primary'
          break
        case '已完成':
          nowState = 'info'
          break
      }
      return nowState
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
td.available div span {
  color: red !important;
}
.key {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
::v-deep .el-input__inner {
  width: 224px;
  height: 32px;
  border-radius: 0;
}
::v-deep .el-input__suffix {
  top: 15%;
}
.el-input {
  width: 70%;
}
.el-range-editor.el-input__inner {
  padding: 0;
  width: 256px;
}
::v-deep .el-date-editor .el-range-separator {
  color: rgba(0, 0, 0, 0.25);
}
::v-deep .el-date-editor .el-range__icon {
  position: absolute;
  top: 0;
  right: 5px;
}
.tab-programme-a {
  margin-top: 0px !important;
  width: 70px;
  height: 32px;
  line-height: 32px;
}
.container {
  background-color: #f5f5f5;
}
.main-in {
  background-color: #fff;
  padding: 24px 28px 24px 24px;
  min-width: 1580px;
}
.main-in p {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 29px;
  display: flex;
  align-items: center;
}
.table /deep/tbody tr:hover > td {
  cursor: pointer;
  background-color: #fafafa;
}
.dialog {
  border-top: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
.key {
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
  line-height: 22px;
}
.details {
  height: 144px;
  border: 1px solid #d9d9d9;
  margin-top: 12px;
  padding: 4px 14px 0 12px;
}
.pagination {
  margin-top: 24px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #77ba00;
  border: none;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #606266;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-pagination button {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
</style>
